import type { Saga } from "redux-saga";
import {
  call, takeEvery, put, select,
} from "redux-saga/effects";
import {
  addNotification, setTableSelection, getTableSelections, parseResponse,
  type DataItem,
} from "@fas/ui-framework";
import { DELETE_REDIRECT_LIST_SAGA, REDIRECT_LIST } from "../../helpers/constants";
import RedirectApi from "../../services/redirectApi";
import { getRedirectList } from "../../actions/redirectList";
import setLoading from "../../actions/loading";

export function* makeFetch() {
  try {
    yield put(setLoading(REDIRECT_LIST, true));
    const selected: Array<DataItem> = yield select(getTableSelections, REDIRECT_LIST);
    yield call(RedirectApi.deleteRedirect, selected.map((i) => i.id) as any);
    yield put(addNotification({ message: "Redirect deleted", severity: "success" }));
    yield put(setTableSelection(REDIRECT_LIST, []));
    yield put(getRedirectList());
  }
  catch (error: any) {
    yield put(addNotification({ message: parseResponse(error), severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading(REDIRECT_LIST, false));
  }
}

export default function* watch() {
  yield takeEvery(DELETE_REDIRECT_LIST_SAGA, makeFetch);
}
